<div class="dialog" data-testid="kyc-cpf-ack-modal">
  <div class="title-container">
    <div class="title-left">
      <mat-icon class="icon-title">badge</mat-icon>
      <h3 class="title" data-testid="kyc-cpf-ack-modal-title">
        {{ 'KycCpfAckTitle' | translate }}
      </h3>
    </div>
  </div>

  <div class="desc" data-testid="kyc-cpf-ack-modal-message">
    {{ 'KycCpfAckExplanation' | translate }}
  </div>

  <div class="attestations">
    <mat-checkbox
      color="primary"
      [(ngModel)]="presentAttested"
      data-testid="kyc-cpf-ack-present"
    >
      {{ 'KycCpfAckPresentAttest' | translate }}
    </mat-checkbox>

    <mat-checkbox
      color="primary"
      [(ngModel)]="riskAttested"
      data-testid="kyc-cpf-ack-risk"
    >
      {{ 'KycCpfAckRiskAttest' | translate }}
    </mat-checkbox>
  </div>

  <div class="contact-note" data-testid="kyc-cpf-ack-contact-note">
    {{ 'KycCpfAckContactNote' | translate }}
  </div>

  <div class="actions">
    <button
      class="def-button confirm-btn"
      color="primary"
      [disabled]="!canConfirm"
      (click)="onConfirm()"
      data-testid="kyc-cpf-ack-confirm"
    >
      {{ 'KycCpfAckConfirm' | translate }}
    </button>
    <button
      class="def-button cancel-btn"
      (click)="onCancel()"
      data-testid="kyc-cpf-ack-cancel"
    >
      {{ 'KycRetakeDocument' | translate }}
    </button>
  </div>
</div>
